import { SET_IMPORT_ERROR } from '../../../actions/entity';

export default (state = [], action) => {
  switch (action.type) {
    case SET_IMPORT_ERROR:
      return action.payload.codes;
    default:
      return state;
  }
};

export const getCodes = state => state;